
// Mock data for reports page

// Format data for the order status pie chart
export const orderStatusData = [
  { name: 'Nalevering', value: 156 },
  { name: 'Volledig', value: 845 },
  { name: 'Incident', value: 42 },
  { name: 'Afwijkend', value: 87 }
];

// Format data for the order route bar chart
export const orderRouteData = [
  { name: 'Route A', value: 240 },
  { name: 'Route B', value: 310 },
  { name: 'Route C', value: 280 },
  { name: 'Route D', value: 200 }
];

// Format data for the monthly orders line chart
export const monthlyOrdersData = [
  { name: 'Jan', orders: 42 },
  { name: 'Feb', orders: 38 },
  { name: 'Mar', orders: 45 },
  { name: 'Apr', orders: 39 },
  { name: 'May', orders: 47 },
  { name: 'Jun', orders: 43 }
];

// Format data for the incidents pie chart
export const incidentsData = [
  { name: 'Beschadiging', value: 18 },
  { name: 'Verkeerde Kleur', value: 12 },
  { name: 'Ontbrekend Item', value: 8 },
  { name: 'Levertijd', value: 4 }
];

// Monthly incidents data
export const monthlyIncidents = [
  { month: 'Jan', incidents: 6 },
  { month: 'Feb', incidents: 5 },
  { month: 'Mar', incidents: 7 },
  { month: 'Apr', incidents: 6 },
  { month: 'May', incidents: 8 },
  { month: 'Jun', incidents: 6 }
];

// Mock data for colors report
export const colorsData = [
  { name: 'RAL 9010', value: 156 },
  { name: 'RAL 9001', value: 132 },
  { name: 'RAL 7016', value: 98 },
  { name: 'RAL 5015', value: 76 },
  { name: 'RAL 3020', value: 65 },
  { name: 'NCS S0500N', value: 54 },
  { name: 'Overige', value: 243 }
];

// Mock data for kleur beschikbaarheid
export const kleurBeschikbaarheid = [
  { name: 'Direct leverbaar', value: 68 },
  { name: 'Op bestelling', value: 22 },
  { name: 'Niet leverbaar', value: 10 }
];

// Mock data for comments report
export const commentsData = [
  { name: 'Product', value: 42 },
  { name: 'Levering', value: 37 },
  { name: 'Kleur', value: 25 },
  { name: 'Prijs', value: 18 },
  { name: 'Service', value: 15 },
  { name: 'Overige', value: 23 }
];

// Mock data for comments processing
export const commentsProcessingData = [
  { name: 'Product', verwerkt: 35, openstaand: 7 },
  { name: 'Levering', verwerkt: 30, openstaand: 7 },
  { name: 'Kleur', verwerkt: 20, openstaand: 5 },
  { name: 'Prijs', verwerkt: 15, openstaand: 3 },
  { name: 'Service', verwerkt: 12, openstaand: 3 },
  { name: 'Overige', verwerkt: 18, openstaand: 5 }
];

// Mock data for inventory report
export const inventoryData = [
  { name: 'Binnen norm', value: 76 },
  { name: 'Onder minimum', value: 12 },
  { name: 'Boven maximum', value: 8 },
  { name: 'Uitlopend', value: 4 }
];

// Mock data for inventory trend
export const inventoryTrendData = [
  { month: 'Jan', voorraad: 240 },
  { month: 'Feb', voorraad: 255 },
  { month: 'Mar', voorraad: 270 },
  { month: 'Apr', voorraad: 230 },
  { month: 'May', voorraad: 265 },
  { month: 'Jun', voorraad: 275 }
];

// Mock data for deviant orders
export const deviantOrdersData = [
  { month: 'Jan', afwijkend: 12, normaal: 142 },
  { month: 'Feb', afwijkend: 15, normaal: 138 },
  { month: 'Mar', afwijkend: 14, normaal: 156 },
  { month: 'Apr', afwijkend: 10, normaal: 144 },
  { month: 'May', afwijkend: 16, normaal: 162 },
  { month: 'Jun', afwijkend: 12, normaal: 148 }
];

// Mock data for deviant reasons
export const deviantReasonsData = [
  { name: 'Voorraadtekort', value: 42 },
  { name: 'Kleurprobleem', value: 28 },
  { name: 'Productfout', value: 18 },
  { name: 'Orderwijziging', value: 12 }
];

// Mock data for transport damage
export const transportDamageData = [
  { name: 'Eigen vervoer', value: 8 },
  { name: 'PostNL', value: 23 },
  { name: 'DHL', value: 17 },
  { name: 'Overige vervoerders', value: 12 }
];

// Mock data for transport damage trend
export const transportDamageTrendData = [
  { month: 'Jan', schades: 10 },
  { month: 'Feb', schades: 12 },
  { month: 'Mar', schades: 8 },
  { month: 'Apr', schades: 15 },
  { month: 'May', schades: 9 },
  { month: 'Jun', schades: 14 }
];
